import { ReviewRating } from "./../../views/UIelems/v2/reviewRating/ReviewRating";

export const ReviewRatingWrapper = ({ rating, reviewCount, clsn = [] }) => {
  return (
    <div className="mb-8">
      {rating && <ReviewRating rating={rating} totalReviews={reviewCount} clsn={clsn} />}
    </div>
  );
};
